import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            component: () => import('../components/page/loginPage/Login.vue'),
            meta: { title: '登录' }
        },
    {
        path: '/register',
        component: () => import('../components/page/loginPage/Register.vue'),
        meta: { title: '注册' }
    },
    {
        path: '/resetPassword',
        component: () => import('../components/page/loginPage/ResetPassword.vue'),
        meta: { title: '忘记密码' }
    },
    {
        path: '/dashboard',
        component: () => import('../components/page/Dashboard.vue'),
        meta: { title: '导航' }
    },
    {
        path: '/',
        component: () => import('../components/common/Home.vue'),
        meta: { title: '自述文件' },
        children: [
            {
                path: '/index',
                component: () => import('../components/page/Index.vue'),
                meta: { title: '首页' }
            },
            {
                path: '/dataResources',
                component: () => import('../components/page/dataResources/DataResources.vue'),
                meta: { title: '数据资源' }
            },
            {
                path: '/publicData',
                component: () => import('../components/page/dataResources/PublicData.vue'),
                meta: { title: '公共数据' }
            },
            {
                path: '/uploadResources',
                component: () => import('../components/page/dataResources/UploadResources.vue'),
                meta: { title: '上传资源' }
            },
            {
                path: '/cloudLab',
                component: () => import('../components/page/cloudLabPage/CloudLab.vue'),
                meta: { title: '云实验室' },
            },
            {
                path: '/cloudLabDetail',
                component: () => import('../components/page/cloudLabPage/CloudLabDetail.vue'),
                meta: { title: '云实验室细节' },
            },
            {
                path: '/purchaseResources',
                component: () => import('../components/page/cloudLabPage/PurchaseResources.vue'),
                meta: { title: '购买资源' },
            },
            {
                path: '/other',
                component: () => import('../components/page/Other.vue'),
                meta: { title: '云实验缺省页面' },
            },
            {
                path: '/caseAnalysis',
                component: () => import('../components/page/CaseAnalysis.vue'),
                meta: { title: '案例分析' }
            },
            {
                path: '/cloudClassroom',
                component: () => import('../components/page/cloudClassroomPage/CloudClassroom.vue'),
                meta: { title: '云课堂' },
            },
            {
                path: '/articleCollection',
                component: () => import('../components/page/ArticleCollection.vue'),
                meta: { title: '文章合集' },
            },
            {
                path: '/cloudClassroomProject',
                component: () => import('../components/page/cloudClassroomPage/CloudClassroomProject.vue'),
                meta: { title: '专题列表' },
            },
            {
                path: '/articleDetail',
                component: () => import('../components/page/cloudClassroomPage/ArticleDetail.vue'),
                meta: { title: '专题文章细节' },
            },
            {
                path: '/community',
                component: () => import('../components/page/communityPage/Community.vue'),
                meta: { title: '社区' }
            },
            {
                path: '/communityShare',
                component: () => import('../components/page/communityPage/CommunityShare.vue'),
                meta: { title: '社区共享' }
            },
            {
                path: '/communityDetail',
                component: () => import('../components/page/communityPage/CommunityDetail.vue'),
                meta: { title: '社区文章细节' }
            },
            {
                path: '/communityDetailTwo',
                component: () => import('../components/page/communityPage/CommunityDetailTwo.vue'),
                meta: { title: '社区文章细节' }
            },
            {
                path: '/competition',
                component: () => import('../components/page/competPage/Competition.vue'),
                meta: { title: '竞赛' }
            },
            {
                path: '/competeDetail',
                component: () => import('../components/page/competPage/CompeteDetail.vue'),
                meta: { title: '竞赛细节' }
            },
            {
                path: '/courseDetail',
                component: () => import('../components/page/dataResources/CourseDetail.vue'),
                meta: {
                    title: '课程详情',
                }
            },
            {
                path: '/personalCenter',
                component: () => import('../components/page/personalInfo/PersonalCenter.vue'),
                meta: { title: '个人中心' }
            },
            {
                path: '/noticeInfo',
                component: () => import('../components/page/personalInfo/NoticeInfo.vue'),
                name:'noticeInfo',
                meta: { title: '通知信息' }
            },
            {
                path: '/taskDetail',
                component: () => import('../components/page/personalInfo/TaskDetail.vue'),
                meta: { title: '任务详情' }
            },
            {
                path: '/modifyInfo',
                component: () => import('../components/page/personalInfo/ModifyInfo.vue'),
                meta: { title: '个人设置' }
            },
            {
                path: '/companyProfile',
                component: () => import('../components/page/CompanyProfile.vue'),
                meta: { title: '公司介绍' }
            },
            {
                path: '/computeResource',
                component: () => import('../components/page/cloudLabPage/ComputeResource.vue'),
                meta: { title: '智能计算资源' }
            },

            // 数据资源导航
            {
                path: '/main',
                component: () => import('../components/page/Main.vue'),
                meta: { title: 'MS 数据资源库' }
            },
            {
                path: '/index',
                component: () => import('../components/page/Index.vue'),
                meta: { title: '首页' }
            },
            {
                path: '/dataSource',
                component: () => import('../components/page/DataSource.vue'),
                meta: { title: 'MS 数据资源库' }
            },

            {
                path: '/commonData',
                component: () => import('../components/page/CommonData.vue'),
                meta: { title: '通用数据' }
            },
            {
                path: '/dataSourceStockData',
                component: () => import('../components/page/DataSourceStockData.vue'),
                meta: { title: '股票数据' }
            },
            {
                path: '/dataSourceFuturesData',
                component: () => import('../components/page/DataSourceFuturesData.vue'),
                meta: { title: '期货数据' }
            },
            {
                path: '/researchData',
                component: () => import('../components/page/ResearchData.vue'),
                meta: { title: '科研合作数据' }
            },
            {
                path: '/scientificData',
                component: () => import('../components/page/ScientificData/ScientificData.vue'),
                meta: { title: '科研合作数据' }
            },
            {
                path: '/macroData',
                component: () => import('../components/page/MacroData.vue'),
                meta: { title: '宏观数据' }
            },
            {
                path: '/optionData',
                component: () => import('../components/page/OptionData.vue'),
                meta: { title: '期权数据' }
            },
            {
                path: '/foreignData',
                component: () => import('../components/page/ForeignData.vue'),
                meta: { title: '外汇数据' }
            },
            {
                path: '/energyData',
                component: () => import('../components/page/EnergyData.vue'),
                meta: { title: '能源数据' }
            },
            {
                path: '/otherData',
                component: () => import('../components/page/OtherData.vue'),
                meta: { title: '另类数据' }
            },
            {
                path: '/accountingData',
                component: () => import('../components/page/AccountingData.vue'),
                meta: { title: '财会数据' }
            },
            {
                path: '/dataApi',
                name: 'dataApi',
                component: () => import('../components/page/DataApi.vue'),
                meta: { title: 'MS 数据 API 文档' }
            },
            {
                // 国际化组件
                path: '/i18n',
                component: () => import('../components/page/I18n.vue'),
                meta: { title: '国际化' }
            },
            {
                // 404报错
                path: '/404',
                component: () => import('../components/page/404.vue'),
                meta: { title: '404' }
            },
            {
                // 维护页面
                path: '/maintainPage',
                component: () => import('../components/page/maintainPage/MaintainPage.vue'),
                meta: { title: '维护中...' }
            },
        ]
    }
    ]
});
